import { TNewbuildingBrokerConfig } from '../../../types/brokerConfig';
import { useApplicationContext } from '../../../utils/applicationContext';

export const useBrokerConfig = (): TNewbuildingBrokerConfig => {
  const { config } = useApplicationContext();

  const brokerConfig: TNewbuildingBrokerConfig | null = config.get('newbuildingBroker');

  return {
    enabled: brokerConfig?.enabled || false,
    personalDataAgreement: brokerConfig?.personalDataAgreement || '',
    landingUrl: brokerConfig?.landingUrl || '',
  };
};
